import React/* , { useRef } */ from "react";
import { useDispatch } from "react-redux";
import moment from "moment";
import "moment/locale/es"; // without this line it didn't work
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import CheckIcon from "@material-ui/icons/Check";
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { makeStyles } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Paper, Grid, Fab, MenuItem } from "@material-ui/core";
import { useForm } from "../../hooks/useForm";
import { TarjetaCertificado } from "../Documentacion/TarjetaCertificado";
import { certificadoStageStartUpdate, certificadoStartUpdate, deleteCertificado, deleteCertificadoStage } from "../../actions/certificados";
import { prepareCertificado } from "../../helpers/prepareCertificado";
import ValidatedDatePicker from "../compartidos/ValidatedDatePicker";
import { SelectValidator, ValidatorForm } from "react-material-ui-form-validator";
import { TIPO_CERTIFICADOS } from "../../utils/constants";
moment.locale("es");

const useStyles = makeStyles({
  buttonOk: {
    marginRight: 10,
  },
  buttonDelete: {
    marginRight: 10,
    backgroundColor: "red"
  },
  title: {
    fontSize: 14,
    padding: 10,
  },
  pos: {
    marginBottom: 12,
  },
  container: {
    marginTop: "1.5em",
    padding: 10
  },
  autocompletar: {
    backgroundColor: "#90ee90",
  },
  contenidoTexto: {
    fontSize: 14,
    padding: 2,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  texto: {
    fontSize: 14,
    padding: 12,
  },
});

const centerStyle= {display: "flex", justifyContent: "center", alignItems: "center"}

export const CertificadoAfiliadoItem = ({ item, esPreAfiliacion, idPreAfiliado }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [
    formValues,
    ,
    ,
    setearValor,
    ,
  ] = useForm(item);

  const { tipoCertificado, fecha, fechaVencimiento, fecha2doVencimiento, fechaActualizacion } = formValues;

  const handleCertificadoUpdate = async (e) => {
    e.preventDefault()
    const certEnviar = {
      ...item,
      formValues,
      fechaModificacion: null,
    };

    const prepared = await prepareCertificado(certEnviar);
    esPreAfiliacion ? dispatch(certificadoStageStartUpdate(prepared)) : dispatch(certificadoStartUpdate(prepared));
  };

  const handleCertificadoDelete = () => {
    esPreAfiliacion ? dispatch(deleteCertificadoStage(item.idItem, idPreAfiliado)) : dispatch(deleteCertificado(item.idItem));
  };

  return (
    <Paper elevation={3} className={classes.container}>
      <ValidatorForm onSubmit={handleCertificadoUpdate}>
        <Grid
          spacing={2}
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <Grid item xs={12} md={2}>
            <SelectValidator
              value={tipoCertificado}
              // onChange={(e) => {
              //   handleInputChange(e);
              // }}
              disabled
              label="Certificado"
              name="tipoCertificado"
              validators={["required"]}
              errorMessages={["El tipo es requerido"]}
              fullWidth
            >
              <MenuItem value="">
                <em>Seleccione</em>
              </MenuItem>
              <MenuItem value={TIPO_CERTIFICADOS.ESTUDIO}>ESTUDIOS</MenuItem>
              <MenuItem value={TIPO_CERTIFICADOS.DISCAPACIDAD}>DISCAPACIDAD</MenuItem>
              <MenuItem value={TIPO_CERTIFICADOS.PMI}>PMI</MenuItem>
            </SelectValidator>
          </Grid>
          <Grid item xs={12} md={7}>
            <Grid container justify="flex-start" style={{gap: "2em"}}>

              <Grid item xs={12} md={3}>
                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                  <ValidatedDatePicker
                    margin="normal"
                    id={`dialogFecha${item.idItem}`}
                    label="Fecha de Vigencia"
                    format="dd/MM/yyyy"
                    okLabel="Aceptar"
                    maxDate={new Date()} //maxDate
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    value={moment(fecha).isValid() ? moment(fecha) : null}
                    fullWidth
                    onChange={(date) => {
                      setearValor("fecha", date);
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    validators={["required"]}
                    errorMessages={["La fecha es requerida"]}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              {/*!fechaActualizacion && Comentado a Pedido de Adrian*/ (
                <Grid item xs={12} md={3}>
                  <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                    <ValidatedDatePicker
                      margin="normal"
                      id={`dialogFechavencimiento${item.idItem}`}
                      label="Fecha Vencimiento"
                      format="dd/MM/yyyy"
                      okLabel="Aceptar"
                      minDate={new Date()} //maxDate
                      clearLabel="Limpiar"
                      cancelLabel="Cancelar"
                      fullWidth
                      disabled={!!fechaActualizacion}
                      value={
                        moment(fechaVencimiento).isValid()
                          ? moment(fechaVencimiento)
                          : null
                      }
                      onChange={(date) => {
                        setearValor("fechaVencimiento", date);
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      {...(!fechaActualizacion && {
                        validators: ["required"],
                        errorMessages: ["La fecha de vencimiento es requerida"]
                      })}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              )}
              {tipoCertificado === 2 && /*!fechaActualizacion && Comentado a Pedido de Adrian*/ (
                <Grid item xs={12} md={3}>
                  <ValidatedDatePicker
                    margin="normal"
                    id={`dialogFecha2doVencimiento${item.idItem}`}
                    label="Fecha 2do Vencimiento"
                    format="dd/MM/yyyy"
                    okLabel="Aceptar"
                    minDate={fechaVencimiento}
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    fullWidth
                    disabled={!!fechaActualizacion}
                    value={
                      moment(fecha2doVencimiento).isValid()
                        ? moment(fecha2doVencimiento)
                        : null
                    }
                    onChange={(date) => {
                      setearValor("fecha2doVencimiento", date);
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    {...(!fechaActualizacion && {
                      validators: ["required"],
                      errorMessages: ["La fecha de segundo vencimiento es requerida"]
                    })}
                  />
                </Grid>
              )}
              {tipoCertificado === 2 && !fechaVencimiento && !fecha2doVencimiento && (
                <Grid item xs={12} md={2}>
                  <ValidatedDatePicker
                    margin="normal"
                    id={`dialogFechaActualizacion${item.idItem}`}
                    label="Fecha Actualizacion"
                    format="dd/MM/yyyy"
                    okLabel="Aceptar"
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    disabled={!!fechaVencimiento || !!fecha2doVencimiento}
                    fullWidth
                    value={
                      moment(fechaActualizacion).isValid()
                        ? moment(fechaActualizacion)
                        : null
                    }
                    onChange={(date) => {
                      setearValor("fechaActualizacion", date);
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    {...(!fechaVencimiento && !fecha2doVencimiento && {
                        validators: ["required"],
                        errorMessages: ["La fecha de actualizacion es requerida"]
                    })}
                  />
                </Grid>
              )} 
            </Grid>
          </Grid>
          <Grid item xs={12} md={1} style={centerStyle}>
            <Fab
              className={classes.buttonOk}
              variant="extended"
              color="primary"
              aria-label="add"
              size="medium"
              type={"submit"}
            >
              <CheckIcon />
            </Fab>
            <Fab
              className={classes.buttonDelete}
              variant="extended"
              color="primary"
              aria-label="delete"
              size="medium"
              type={"button"}
              onClick={handleCertificadoDelete}
            >
              <DeleteForeverIcon />
            </Fab>
          </Grid>
          <Grid item xs={12} md={2} style={centerStyle}>
            <TarjetaCertificado
              esPreAfiliacion={esPreAfiliacion}
              idPreAfiliado={idPreAfiliado}
              urls={item.imagenCertificado}
              idItem={item.idItem}
              titulo={
                tipoCertificado === TIPO_CERTIFICADOS.ESTUDIO
                  ? `Estudios`
                  : tipoCertificado === TIPO_CERTIFICADOS.DISCAPACIDAD
                    ? `Discapacidad`
                    : `PMI`
              }
            />
          </Grid>
        </Grid>
      </ValidatorForm>
    </Paper>
  );
};

